import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAffiliate from '../reducers/affiliate.reducer';

export const selectAffiliateState = createFeatureSelector<fromAffiliate.State>(fromAffiliate.affiliateFeatureKey);

export const selectAffiliateHash = createSelector(selectAffiliateState, (state) => state.hash);

export const selectAffiliateProfileState = createSelector(selectAffiliateState, (state) => state.profile);
